import { useQuery } from 'react-query';
import { connectGitHub, getGitHubContributions } from 'src/apis/github';
import { BaseAPIResponse, GitHubContributionsAPIResponse } from 'types';

export const useConnectGitHub = (
	id?: string,
	onComplete?: (data: BaseAPIResponse) => void,
	handleError?: () => void,
) => {
	return useQuery({
		queryKey: ['connectGitHub', id],
		queryFn: async () => (await connectGitHub()) as BaseAPIResponse,
		staleTime: 0,
		enabled: !!id,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};

export const useGetGitHubContributions = (
	userId: string,
	onComplete?: (data: GitHubContributionsAPIResponse) => void,
	handleError?: () => void,
) => {
	return useQuery({
		queryKey: ['getGitHubContributions', userId],
		queryFn: async () => (await getGitHubContributions(userId)) as GitHubContributionsAPIResponse,
		staleTime: 0,
		enabled: !!userId,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};
